import CryptoJS from 'crypto-js'
import { getCookie, HttpFactory, zhlType, submitErrorLog } from '@/assets/js/common'
//APPID，APISecret，APIKey在控制台-我的应用-语音评测（流式版）页面获取
// const APPID = "52a92404";
// const API_SECRET = "MWM5OThjOGU3NTE2YjY1NzViYTBmOGMz";
// const API_KEY = "ce3e48187919f683a50ce33251babbc9";
const APPID = '7ecd9c58'
const API_SECRET = 'NzllMWEwYzY3OTlmMTZhOTEzZjg2ZGUz'
const API_KEY = '64f4d5d6984032b48d353eb2c2e730df'
/**
 * 获取websocket url
 * 该接口需要后端提供，这里为了方便前端处理
 */
function getWebSocketUrl() {
  // 请求地址根据语种不同变化
  var url = 'wss://iat-api.xfyun.cn/v2/iat'
  var host = 'iat-api.xfyun.cn'
  var apiKey = API_KEY
  var apiSecret = API_SECRET
  var date = new Date().toGMTString()
  var algorithm = 'hmac-sha256'
  var headers = 'host date request-line'
  var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`
  var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret)
  var signature = CryptoJS.enc.Base64.stringify(signatureSha)
  var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
  var authorization = btoa(authorizationOrigin)
  url = `${url}?authorization=${authorization}&date=${date}&host=${host}`
  return url
}

const recorder = new RecorderManager('./kdxf-yysb-dist')
class YYSBRecoder {
  constructor() {
    this.btnStatus = 'UNDEFINED' // "UNDEFINED" "CONNECTING" "OPEN" "CLOSING" "CLOSED"
    this.iatWS = ''
    this.resultText = ''
    this.resultTextTemp = ''
    this.countdownInterval = null

    //-音频合成相关变量：start
    this.audioContext = null
    //录音文件长度
    this.size = 0
    //录音缓存
    this.buffer = []
    //输入采样率
    this.inputSampleRate = 44100
    //输入采样数位 8, 16
    this.inputSampleBits = 16
    // 输出采样率共分为11025Hz、22050Hz、24000Hz、44100Hz、48000Hz五个等级，
    // 11025Hz能达到AM调幅广播的声音品质，而22050Hz和24000HZ能达到FM调频广播的声音品质，
    // 44100Hz则是理论上的CD音质界限，48000Hz则更加精确一些
    this.outputSampleRate = 44100 / 2
    //输出采样数位 8, 16
    this.oututSampleBits = 8
    //音频合成相关变量：-end

    this.newStart = true // 用于控制产生多次结果
    recorder.onFrameRecorded = ({ isLastFrame, frameBuffer }) => {
      if (this.iatWS.readyState === this.iatWS.OPEN) {
        this.iatWS.send(
          JSON.stringify({
            data: {
              status: isLastFrame ? 2 : 1,
              format: 'audio/L16;rate=16000',
              encoding: 'raw',
              audio: this.toBase64(frameBuffer)
            }
          })
        )
        if (isLastFrame) {
          this.changeBtnStatus('CLOSING')
        }
      }
    }
    recorder.onStop = () => {
      clearInterval(this.countdownInterval)
    }
  }
  // startRecord() {
  //   if (!this.audioContext) {
  //     this.recorderInit()
  //   } else {
  //     this.audioContext.resume()
  //     this.connectWebSocket();
  //   }
  // }
  // 初始化浏览器录音
  recorderInit(testPermission) {
    this.newStart = true
    //-音频合成相关，清空历史:start
    this.buffer = []
    this.size = 0
    //-音频合成相关，清空历史:end
    navigator.getUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia

    // 创建音频环境
    try {
      this.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)()
      this.audioContext.resume()
      if (!this.audioContext) {
        alert('浏览器不支持webAudioApi相关接口')
        return
      }
    } catch (e) {
      if (!this.audioContext) {
        alert('浏览器不支持webAudioApi相关接口')
        submitErrorLog('recorderInit-浏览器不支持webAudioApi相关接口', e)
        return
      }
    }

    // 获取浏览器录音权限
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({
          audio: true,
          video: false
        })
        .then(stream => {
          console.log('录音权限OK')
          if (testPermission) {
            getMediaSuccess(stream)
          } else {
            this.stopRecord()
          }
        })
        .catch(e => {
          getMediaFail(e)
        })
    } else if (navigator.getUserMedia) {
      navigator.getUserMedia(
        {
          audio: true,
          video: false
        },
        stream => {
          getMediaSuccess(stream)
        },
        function(e) {
          getMediaFail(e)
        }
      )
    } else {
      if (
        navigator.userAgent.toLowerCase().match(/chrome/) &&
        location.origin.indexOf('https://') < 0
      ) {
        alert(
          'chrome下获取浏览器录音功能，因为安全性问题，需要在localhost或127.0.0.1或https下才能获取权限'
        )
      } else {
        alert('无法获取浏览器录音功能，请升级浏览器或使用chrome')
      }
      this.audioContext && this.audioContext.close()
      return
    }
    // 获取浏览器录音权限成功的回调
    let getMediaSuccess = stream => {
      console.log('getMediaSuccess')
      //-音频合成相关赋值
      this.inputSampleRate = this.audioContext.sampleRate
      // 创建一个用于通过JavaScript直接处理音频
      this.scriptProcessor = this.audioContext.createScriptProcessor(0, 1, 1)
      this.scriptProcessor.onaudioprocess = e => {
        // 去处理音频数据
        if (this.btnStatus === 'OPEN') {
          //-音频合成相关数据
          this.input(e.inputBuffer.getChannelData(0))
          // transWorker.postMessage(e.inputBuffer.getChannelData(0))
        }
      }
      // 创建一个新的MediaStreamAudioSourceNode 对象，使来自MediaStream的音频可以被播放和操作
      this.mediaSource = this.audioContext.createMediaStreamSource(stream)
      console.log('mediaSource:', this.mediaSource)
      // 连接
      this.mediaSource.connect(this.scriptProcessor)
      this.scriptProcessor.connect(this.audioContext.destination)
      this.connectWebSocket()
    }

    let getMediaFail = e => {
      alert('请求麦克风失败')
      console.log(e)
      this.audioContext && this.audioContext.close()
      this.audioContext = undefined
      // 关闭websocket
      if (this.iatWS && this.iatWS.readyState === 1) {
        this.iatWS.close()
      }
      submitErrorLog('getMediaFail-请求麦克风失败', e || '请求麦克风失败')
    }
  }
  stopRecord() {
    try {
      // safari下suspend后再次resume录音内容将是空白，设置safari下不做suspend
      if (
        !(
          /Safari/.test(navigator.userAgent) &&
          !/Chrome/.test(navigator.userAgent)
        )
      ) {
        this.audioContext && this.audioContext.suspend()
      }
      recorder.stop()
      this.changeBtnStatus('CLOSED')
    } catch (e) {
      submitErrorLog('stopRecord-停止录音失败', e || '停止录音失败')
    }
  }
  // getResultCallback(result){
  //   console.log('Recorder 处理后的结果', result)
  // }
  toBase64(buffer) {
    var binary = ''
    var bytes = new Uint8Array(buffer)
    var len = bytes.byteLength
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i])
    }
    return window.btoa(binary)
  }
  countdown() {
    let seconds = 60
    this.countdownInterval = setInterval(() => {
      seconds = seconds - 1
      if (seconds <= 0) {
        clearInterval(this.countdownInterval)
        recorder.stop()
      } else {
        // btnControl.innerText = `录音中（${seconds}s）`;
      }
    }, 1000)
  }
  changeBtnStatus(status) {
    this.btnStatus = status
    if (status === 'CONNECTING') {
      // btnControl.innerText = "建立连接中";
      // document.getElementById("result").innerText = "";
      this.resultText = ''
      this.resultTextTemp = ''
    } else if (status === 'OPEN') {
      this.countdown()
    } else if (status === 'CLOSING') {
      // btnControl.innerText = "关闭连接中";
    } else if (status === 'CLOSED') {
      // btnControl.innerText = "开始录音";
    }
  }
  renderResult(resultData) {
    try {
      // 识别结束
      let jsonData = JSON.parse(resultData)
      if (jsonData.data && jsonData.data.result) {
        let data = jsonData.data.result
        let str = ''
        let ws = data.ws
        for (let i = 0; i < ws.length; i++) {
          str = str + ws[i].cw[0].w
        }
        console.log(jsonData)
        // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
        // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
        if (data.pgs) {
          if (data.pgs === 'apd') {
            // 将resultTextTemp同步给resultText
            this.resultText = this.resultTextTemp
          }
          // 将结果存储在resultTextTemp中
          this.resultTextTemp = this.resultText + str
        } else {
          this.resultText = this.resultText + str
        }
        const result = this.resultTextTemp || this.resultText || ''
        if (this.newStart) {
          this.getResultCallback(
            JSON.stringify({
              // duration: 60, // 录音时长 秒
              // audioUrl: 'https://zhldebug.cdn.bcebos.com/CACAAECJ/e6a8b9d0c8f74f97b2b2322a2f245ee9.mp3', // 地址
              resultStr: result || 'Unrecognized' // 录音结果： 评测的时候就是传入的评测字符串， 识别的时候是识别出的文字
            })
          )
        }
        this.newStart = false
        // document.getElementById("result").innerText =
        //   resultTextTemp || resultText || "";
      }
      if (jsonData.code === 0 && jsonData.data.status === 2) {
        this.iatWS.close()
      }
      if (jsonData.code !== 0) {
        this.iatWS.close()
        console.error(jsonData)
      }
    } catch (error) {
      submitErrorLog('renderResult-解析数据失败', error)
    }
  }
  connectWebSocket() {
    const websocketUrl = getWebSocketUrl()
    if ('WebSocket' in window) {
      this.iatWS = new WebSocket(websocketUrl)
    } else if ('MozWebSocket' in window) {
      this.iatWS = new MozWebSocket(websocketUrl)
    } else {
      alert('浏览器不支持WebSocket')
      return
    }
    this.changeBtnStatus('CONNECTING')
    this.iatWS.onopen = e => {
      // 开始录音
      recorder.start({
        sampleRate: 16000,
        frameSize: 1280
      })
      var params = {
        common: {
          app_id: APPID
        },
        business: {
          language: 'en_us',
          domain: 'iat',
          accent: 'mandarin',
          vad_eos: 10000,
          dwa: 'wpgs'
        },
        data: {
          status: 0,
          format: 'audio/L16;rate=16000',
          encoding: 'raw'
        }
      }
      this.iatWS.send(JSON.stringify(params))
      this.changeBtnStatus('OPEN')
    }
    this.iatWS.onmessage = e => {
      this.renderResult(e.data)
    }
    this.iatWS.onerror = e => {
      console.error(e)
      recorder.stop()
      this.changeBtnStatus('CLOSED')
    }
    this.iatWS.onclose = e => {
      recorder.stop()
      this.changeBtnStatus('CLOSED')
    }
  }

  //-音频合成相关方法：start------------------------------------------------------------------------

  input(data) {
    this.buffer.push(new Float32Array(data))
    this.size += data.length
  }
  compress() {
    try {
      //合并压缩
      //合并
      const data = new Float32Array(this.size)
      let offset = 0
      for (let i = 0; i < this.buffer.length; i++) {
        data.set(this.buffer[i], offset)
        offset += this.buffer[i].length
      }
      //压缩
      let compression = parseInt(this.inputSampleRate / this.outputSampleRate)
      console.log('压缩率', this.inputSampleRate, this.outputSampleRate)
      if (compression < 1) {
        compression = 1
      }
      const length = data.length / compression
      const result = new Float32Array(length)
      let index = 0,
        j = 0
      while (index < length) {
        result[index] = data[j]
        j += compression
        index++
      }
      return result
    } catch (error) {
      submitErrorLog('compress-压缩失败', error)
    }
  }
  encodeWAV() {
    let s
    const sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate)
    const sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits)
    const bytes = this.compress()
    const dataLength = bytes.length * (sampleBits / 8)
    const buffer = new ArrayBuffer(44 + dataLength)
    const data = new DataView(buffer)

    const channelCount = 1 //单声道
    let offset = 0

    const writeString = function(str) {
      for (let i = 0; i < str.length; i++) {
        data.setUint8(offset + i, str.charCodeAt(i))
      }
    }

    // 资源交换文件标识符
    writeString('RIFF')
    offset += 4
    // 下个地址开始到文件尾总字节数,即文件大小-8
    data.setUint32(offset, 36 + dataLength, true)
    offset += 4
    // WAV文件标志
    writeString('WAVE')
    offset += 4
    // 波形格式标志
    writeString('fmt ')
    offset += 4
    // 过滤字节,一般为 0x10 = 16
    data.setUint32(offset, 16, true)
    offset += 4
    // 格式类别 (PCM形式采样数据)
    data.setUint16(offset, 1, true)
    offset += 2
    // 通道数
    data.setUint16(offset, channelCount, true)
    offset += 2
    // 采样率,每秒样本数,表示每个通道的播放速度
    data.setUint32(offset, sampleRate, true)
    offset += 4
    // 波形数据传输率 (每秒平均字节数) 单声道×每秒数据位数×每样本数据位/8
    data.setUint32(offset, channelCount * sampleRate * (sampleBits / 8), true)
    offset += 4
    // 快数据调整数 采样一次占用字节数 单声道×每样本的数据位数/8
    data.setUint16(offset, channelCount * (sampleBits / 8), true)
    offset += 2
    // 每样本数据位数
    data.setUint16(offset, sampleBits, true)
    offset += 2
    // 数据标识符
    writeString('data')
    offset += 4
    // 采样数据总数,即数据总大小-44
    data.setUint32(offset, dataLength, true)
    offset += 4
    // 写入采样数据
    if (sampleBits === 8) {
      for (let i = 0; i < bytes.length; i++, offset++) {
        let s = Math.max(-1, Math.min(1, bytes[i]))
        let val = s < 0 ? s * 0x8000 : s * 0x7fff
        val = parseInt(255 / (65535 / (val + 32768)))
        data.setInt8(offset, val, true)
      }
    } else {
      for (let i = 0; i < bytes.length; i++, offset += 2) {
        s = Math.max(-1, Math.min(1, bytes[i]))
        data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true)
      }
    }
    // this.uploadFile(data)
    return new Blob([data], { type: 'audio/wav' })
  }
  //获取音频文件
  getBlob() {
    return this.encodeWAV()
  }
  getAudioLocalUrl() {
    const blob = this.getBlob()
    return window.URL.createObjectURL(blob)
  }

  setAudioUrl(obj, { filedName = 'url', ...param }) {
    const blob = this.getBlob()
    obj[filedName] = window.URL.createObjectURL(blob)
    this.uploadAudioFile(blob, param).then(res => {
      // console.log(res)
      obj[filedName] = res.data.url
    })
  }
  uploadAudioFile(blob, { formDataBack = null }) {
    const fileName = 'WAV' + Date.now() + '.wav'
    const file = new File([blob], fileName, { type: blob.type })
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('business_id', zhlType.getBusinessId())
      formData.append('file_type', 'wav')
      formData.append('name', fileName)
      formData.append('compress_type', 0)
      formData.append('token', getCookie('token'))
      formData.append('filter_sensitive', 0)
      formData.append('folder_id', 0)
      formDataBack && formDataBack(formData)
      HttpFactory.upload(
        formData,
        res => {
          resolve(res)
        },
        err => {
          reject(err)
        },
        true
      )
    })
  }
  //-音频合成相关方法：end
}
export default YYSBRecoder
